import { useLayoutEffect, useState } from 'react';
import { debounce } from 'src/components/muiTheme/utils';

export interface WindowSize {
  width: number;
  height: number;
}

export function useWindowSize(): WindowSize {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const updateValues = debounce(() => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    }, 200);

    window.addEventListener('resize', updateValues);
    updateValues();

    return () => {
      window.removeEventListener('resize', updateValues);
    };
  }, []);

  return {
    width,
    height,
  };
}


